export default __webpack_public_path__ + "static/media/cover.7680c1ec.jpg";